import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { PushNotificationList } from '~/features/PushNotificationList';
import styles from './styles.module.scss';

/**
 * プッシュ通知一覧 Screen（新パターン）
 *
 * PageHeader（タイトル「プッシュ通知」）と PushNotificationList Feature を配置する。
 * PushNotificationList の非同期処理は Suspense でラップし、ロード中は Loader を表示する。
 */
export const Screen: React.FC = () => (
  <>
    <PageHeader variant='title' title='プッシュ通知' />
    <main className={styles.body}>
      <Suspense fallback={<Loader />}>
        <PushNotificationList />
      </Suspense>
    </main>
  </>
);
